import { useEffect, useRef } from 'react'

// A dialog that finishes its work can be taken off the screen by its parent before
// the promise settles; it must not set state afterwards.
export const useIsMounted = (): (() => boolean) => {
  const mounted = useRef(true)

  useEffect(
    () => () => {
      mounted.current = false
    },
    []
  )

  return () => mounted.current
}
